<button type="button" class="btn btn-success w-100" (click)="publishSection()">
    <i [ngClass]="{'fa-spin fa-spinner fa-pulse': isPublishing, 'fa-check': !isPublishing}" class="fa"></i> Publish
</button>
